import { MutationTree } from "vuex";
import { YearmonthState, SET_YEARMONTH } from "./types";

export const mutations: MutationTree<YearmonthState> = {
  [SET_YEARMONTH](state, yearmonth: string) {
    state.yearmonth = yearmonth;
  }
};
